import { makeAutoObservable } from 'mobx';

import type { IPatientsUuid, PatientsViews } from './types';

type WorkspaceListSelection = {
  workspaceUuid: string;
  view: PatientsViews;
  customViewUuid: string | null;
  cohortPicks: string[];
};

export interface IHomepageStore {
  globalFilter: string;
  setGlobalFilter(value: string): void;
  setPatientsUuids(patients: IPatientsUuid[]): void;
  sortedPatientsUuids: IPatientsUuid[];
  listStateWorkspaceUuid: string;
  setListStateWorkspaceUuid(uuid: string): void;
  workspaceListSelection: WorkspaceListSelection | undefined;
  rememberWorkspaceListSelection(selection: WorkspaceListSelection): void;
  resettingWorkspaceUuid: string | undefined;
  workspaceResetVersion: number;
  setResettingWorkspaceUuid(uuid: string | undefined): void;
}

export default class HomepageStore implements IHomepageStore {
  globalFilter = '';
  sortedPatientsUuids = [] as IPatientsUuid[];
  listStateWorkspaceUuid = '';
  workspaceListSelection: WorkspaceListSelection | undefined = undefined;
  resettingWorkspaceUuid: string | undefined = undefined;
  workspaceResetVersion = 0;
  constructor() {
    makeAutoObservable(this);
  }

  setListStateWorkspaceUuid = (uuid: string) => {
    this.listStateWorkspaceUuid = uuid;
  };

  setResettingWorkspaceUuid = (uuid: string | undefined) => {
    this.resettingWorkspaceUuid = uuid;
    if (uuid) this.workspaceResetVersion += 1;
  };

  rememberWorkspaceListSelection = (selection: WorkspaceListSelection) => {
    const previous = this.workspaceListSelection;
    if (
      previous?.workspaceUuid === selection.workspaceUuid &&
      previous.view === selection.view &&
      previous.customViewUuid === selection.customViewUuid &&
      previous.cohortPicks.length === selection.cohortPicks.length &&
      previous.cohortPicks.every((pick, index) => pick === selection.cohortPicks[index])
    )
      return;
    this.workspaceListSelection = selection;
  };

  setGlobalFilter = (value: string) => {
    this.globalFilter = value;
  };

  setPatientsUuids = (uuids: IPatientsUuid[]) => {
    this.sortedPatientsUuids = uuids;
  };
}
